export default "__VITE_ASSET__Cbuevuvf__ 584w";